import { render, staticRenderFns } from "./industryReportDetails.vue?vue&type=template&id=127f1310&scoped=true"
import script from "./industryReportDetails.vue?vue&type=script&lang=js"
export * from "./industryReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f1310",
  null
  
)

export default component.exports